import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import Translate from '../common/Translate';
import useValue from '../../services/Form/useValue';
import ModalMultipleAnomaly from './ModalMultipleAnomaly';
import DisplayAnomaly from './DisplayAnomaly';

const MultipleAnomaly = ({ elementIds, setDisableNav, setNavIsShown, goNextQuestion, question }) => {
  const { questionId, sectionId, formId } = elementIds;
  const [customCostModalShown, setCustomCostModalShown] = useState(false);
  const [children, , refreshChildren] = useValue(formId, sectionId, questionId, question.type, 'children');
  const [value, setValue] = useValue(formId, sectionId, questionId, question.type, 'value');
  const [forceRefresh, setForceRefresh] = useState(true);
  const [selectedElement, setSelectedElement] = useState(null);

  const forceRefreshChilds = () => {
    if (forceRefresh) setForceRefresh(false);
    else setForceRefresh(true);
  };

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (value !== null && value !== '' && value !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
    if (setNavIsShown !== undefined) {
      if (customCostModalShown) setNavIsShown(!customCostModalShown);
      else setNavIsShown(true);
    }
  });

  const hasAnomaly = () => {
    let res;
    if (children) {
      Object.values(children).forEach((v) => {
        if (v.value !== null && v.value !== undefined) res = true;
      });
    }
    return res;
  };

  const handleUpdateDamage = (v) => {
    setSelectedElement(v);
    setCustomCostModalShown(true);
  };

  // reset default value when delete anomaly
  useEffect(() => {
    if (!hasAnomaly() && value === 'add_anomaly') setValue(null);
  }, [children]);

  const onClick = (option) => {
    if (option === 'add_anomaly') {
      setValue(option);
      setSelectedElement(null);
      return setCustomCostModalShown(true);
    }
    if (option === 'ok') {
      if (value === 'ok') return setValue(null);
      setValue(option);
    }
    if (goNextQuestion) goNextQuestion();
    return null;
  };

  const closeModal = async () => {
    await refreshChildren();
    setCustomCostModalShown(false);
    forceRefreshChilds();
  };

  return (
    <div className="before-sticky-bottom" data-cy={questionId}>
      <ModalMultipleAnomaly
        formId={formId}
        sectionId={sectionId}
        listsOption={children}
        isOpen={customCostModalShown}
        closeModal={closeModal}
        questionId={questionId}
        selectedElement={selectedElement}
        questionType={question.type}
      />
      {children !== null &&
        children !== undefined &&
        Object.values(children).map((child) => (
          <Display
            key={child.id}
            id={child.id}
            element={child}
            questionId={questionId}
            sectionId={sectionId}
            formId={formId}
            refreshParent={refreshChildren}
            handleUpdateDamage={handleUpdateDamage}
            closeModal={closeModal}
          />
        ))}
      <Row>
        <Col xs="4" md="3" lg="3">
          <button
            type="button"
            outline="true"
            color="primary"
            className={`btn btn-block btn-value h-100${value === 'ok' && ' selected'}`}
            onClick={() => onClick((value === 'add_anomaly' && 'finish') || 'ok')}
          >
            <Translate code={(value === 'add_anomaly' && 'finish') || 'ok'} />
          </button>
        </Col>
        <Col xs="8" md="3" lg="3">
          <button type="button" className="btn btn-block btn-value h-100" onClick={() => onClick('add_anomaly')}>
            <FontAwesomeIcon className="add-damage-button" size="2x" icon={faPlusCircle} />
            <Translate code="add_anomaly" />
          </button>
        </Col>
      </Row>
    </div>
  );
};

MultipleAnomaly.propTypes = {
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
  setDisableNav: PropTypes.func,
  setNavIsShown: PropTypes.func,
  goNextQuestion: PropTypes.func,
  question: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
};

MultipleAnomaly.defaultProps = {
  setDisableNav: undefined,
  setNavIsShown: undefined,
  goNextQuestion: undefined,
};
export default MultipleAnomaly;

const Display = ({ id, element, formId, sectionId, questionId, refreshParent, handleUpdateDamage, closeModal }) => {
  const [, setValue] = useValue(
    formId,
    sectionId,
    questionId,
    'multiple_anomaly',
    `children.${element.id}.value`,
    '',
    element.id,
    element.type,
  );
  if (element.value === null || element.value === undefined) {
    return null;
  }

  const handleDeleteBlock = async () => {
    setValue(null);
    await closeModal();
    await refreshParent();
  };

  const displayValue = `${element.value} μm`;

  return (
    <DisplayAnomaly
      id={id}
      element={element.id}
      displayValue={displayValue}
      handleDeleteBlock={handleDeleteBlock}
      handleUpdateDamage={handleUpdateDamage}
    />
  );
};

Display.propTypes = {
  id: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  element: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  refreshParent: PropTypes.func.isRequired,
  handleUpdateDamage: PropTypes.func.isRequired,
};
